export default {
  buttons: {
    signup: 'Rekisteröidy',
    login: 'Kirjaudu sisään',
  },
};
